import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickShippingMethodState = createSelector(
  getOneClickState,
  state => state.shippingMethodsState,
);

export const getOneClickShippingMethods = createSelector(
  getOneClickShippingMethodState,
  state => state.shippingMethodsAvailable,
);

export const getOneClickShippingMethodSelected = createSelector(
  getOneClickShippingMethodState,
  state => state.selected,
);
